var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "casino-page-header" },
        [
          _c("div", { staticClass: "group-header casino-page-header-item" }, [
            _vm.groupTitle && !_vm.specialGroupType
              ? _c("h2", { staticClass: "group-name" }, [
                  _vm._v(_vm._s(_vm.$t("" + _vm.groupTitle)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.specialGroupType &&
            !["CasinoMarketingJackpots"].includes(_vm.specialGroupType)
              ? _c("div", { staticClass: "casino-page-logo-title" }, [
                  _c("img", {
                    staticClass: "logo-holder-image",
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/casino/groups/" +
                          _vm.groupData.externalId +
                          "/assets/logo/" +
                          _vm.groupData.externalId +
                          ".svg"
                      ),
                      alt: "",
                      loading: "lazy"
                    }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("casino-tabs", {
            staticClass: "casino-page-header-item",
            attrs: {
              setDefaultTab: 1,
              section: "filterAndSort",
              pageType: _vm.groupSlug,
              itemCount:
                _vm.originalPreparedData && _vm.originalPreparedData.length,
              providers: _vm.providers,
              themeList: _vm.themeList,
              filteredItems: _vm.filteredItems,
              originalPreparedData: _vm.originalPreparedData,
              selectedFilterNumberDisplay: _vm.selectedFilterNumberDisplay
            },
            on: {
              sortTypeSelected: _vm.sortGames,
              filterSelected: _vm.filterSelected
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.specialGroupType
        ? [
            _c(_vm.specialGroupType, {
              key: _vm.componentKey,
              tag: "component",
              attrs: {
                group: _vm.groupData,
                groupRender: false,
                gridView: true
              }
            })
          ]
        : [
            !_vm.groupData || _vm.groupData.gameIds.length === 0
              ? _c("div", { staticClass: "no-games-in-list" }, [
                  _vm._v(_vm._s(_vm.$t("Casino.No.Games")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.groupData
              ? _c("casino-grid-view", {
                  key: _vm.componentKey,
                  attrs: {
                    data: _vm.filterGamesInfoDataByGroup(
                      this.groupData.gameIds
                    ),
                    groupData: _vm.groupData
                  }
                })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30f50c6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f50c6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/CasinoPage.vue
// module id = null
// module chunks = 